import React from 'react'

export const AvatarIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className='icon--avatar'
    viewBox='0 0 32 32'
  >
    <path
      d='M27.4,29.9h-23c-1.3,0-2.4-1.1-2.4-2.4c0.1-2.5,0.5-4.4,4-5.2c2.4-0.5,5.1-1.1,5.7-2.3c0.2-0.5,0.1-1.1-0.3-1.9 C8.5,12.9,8,8.4,9.8,5.3C11,3.3,13.3,2.1,16,2.1c2.7,0,4.9,1.2,6.2,3.2c1.8,3,1.3,7.6-1.5,12.8c-0.4,0.7-0.5,1.3-0.3,1.8 c0.5,1.2,3.1,1.8,5.5,2.4l0.2,0c3.3,0.7,3.9,2.5,3.8,5.2C29.8,28.8,28.7,29.9,27.4,29.9z M16,3.1c-2.4,0-4.3,1-5.3,2.8 C9,8.6,9.6,12.8,12.2,17.7c0.6,1,0.7,2,0.3,2.8c-0.8,1.7-3.6,2.3-6.4,2.9c-2.8,0.6-3.1,1.8-3.2,4.2c0,0.8,0.7,1.4,1.4,1.4h23 c0.9,0,1.4-0.7,1.4-1.4c0.1-2.5-0.3-3.6-3-4.2l-0.2,0c-2.8-0.7-5.4-1.3-6.2-2.9c-0.3-0.8-0.2-1.7,0.3-2.7c2.6-4.9,3.2-9.1,1.5-11.9 C20.2,4.1,18.4,3.1,16,3.1z'
    />
  </svg>
)
